const awsconfig = {
  aws_project_region: 'us-east-1',
  aws_cognito_identity_pool_id: 'us-east-1:54107aec-a14d-4241-9f34-42f64708a0d0',
  aws_cognito_region: 'us-east-1',
  aws_user_pools_id: 'us-east-1_5FvYFX3IZ',
  aws_user_pools_web_client_id: '1avpfe71ji2rm68450ghmh1vel',
  Auth: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_5FvYFX3IZ',
    userPoolWebClientId: '1avpfe71ji2rm68450ghmh1vel',
    identityPoolId: 'us-east-1:54107aec-a14d-4241-9f34-42f64708a0d0'
  }
};
export default awsconfig;
